<template>
    <div class="px-6 replace-screen-wrapper pb-8">
      <v-card class="d-flex align-center hb-grey" outlined>
        <v-avatar size="100" tile>
          <v-img :src="replaceable.featured_image"></v-img>
        </v-avatar>
        <div class="d-flex flex-no-wrap justify-space-between flex-column">
          <v-card-subtitle class="font-weight-bold">
            <div>{{ replaceable.title }}</div>
            <div>$ {{ replaceable.price }}</div>
            
          </v-card-subtitle>
        </div>
      </v-card>
      <!-- <v-alert outlined class="white mt-2 px-0" dense type="error" style="border: none">
        This item is not available for this delivery date.
      </v-alert> -->

      <!-- Replace gift / addon -->
      <template v-if="replaceable.boxContentType !== 'boxType'">
        <div
          class="search-category d-flex align-center justify-space-between mb-4"
        >
          <v-text-field
            placeholder="What are you looking for?"
            prepend-inner-icon="mdi-magnify"
            outlined
            hide-details
            dense
            v-model="search"
          ></v-text-field>
          <button
            @click="toggleCategoryFilter"
            class="filter-button py-2 px-3 ml-3"
          >
            {{ currentCategory }}
          </button>
        </div>
        <div class="products-wrapper justify-space-between">
          <product-card v-for="gift in gifts" :key="gift.id" :giftData="gift" actionText="Replace">
          </product-card>
        </div>
      </template>

      <!-- Replace Gifts -->
      <template v-else>
        <box @next="backToMain"></box>
      </template>
    </div>
    
</template>

<script>
import { TYPE_SET_SCREEN, TYPE_SET_CATEGORY_TOGGLE, TYPE_SET_CURRENT_CATEGORY, TYPE_SET_SUBSTEP } from "../store/mutations";
import ProductCard from "./ProductCard/ProductCard.vue";
import Box from "./Stepper/Box.vue"
export default {
  name: "hb-bab-replace-screen",
  components: {
    ProductCard,
    Box
  },
  data() {
    return {
      step: 1,
      search: "",
    };
  },
  methods: {
    toggleCategoryFilter() {
      this.$store.commit(TYPE_SET_CATEGORY_TOGGLE, true);
    },
    goToGiftCategory() {
      this.substep = 2;
    },
    selectCategory(category) {
      this.substep++;
      this.$store.commit(TYPE_SET_CURRENT_CATEGORY, category);
    },
    backToMain(){
      this.$store.commit(TYPE_SET_SCREEN, 'main')
    }
  },
  computed: {
    categories() {
      return this.$store.getters.categories;
    },
    gifts() {
      return this.$store.getters.filteredGifts.filter((gift) => {
        if (!this.search.length) return true;

        return gift.title.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    replaceToggle: {
      get() {
        return this.$store.state.screen;
      },
      set(value) {
        this.$store.commit(TYPE_SET_SCREEN, value);
      },
    },
    substep: {
      get() {
        return this.$store.state.substep;
      },
      set(value) {
        this.$store.commit(TYPE_SET_SUBSTEP, value);
      },
    },
    currentCategory() {
      return this.$store.state.currentCategory;
    },
    replaceable(){
      return this.$store.state.replaceable;
    }
  },
};
</script>

<style>
</style>